import iaJJImage from 'assets/img/iaPetJJ.png';

const TAMANHO = { pequeno: 'h-10 w-10', grande: 'h-12 w-12' };

/** A ilustração do robô JJ num círculo lilás com borda branca. Decorativa: o nome vem do texto ao lado. */
export default function AvatarDoJJ({ tamanho }: { tamanho: keyof typeof TAMANHO }) {
  return (
    <span
      aria-hidden="true"
      className={`${TAMANHO[tamanho]} flex shrink-0 items-center justify-center overflow-hidden rounded-jj-full border-2 border-solid border-brand-white bg-brand-purple-light`}
    >
      {/* `mix-blend-multiply`: o fundo branco da ilustração some e o lilás do círculo aparece. */}
      <img src={iaJJImage} alt="" className="h-[115%] w-[115%] max-w-none object-contain mix-blend-multiply" />
    </span>
  );
}
